exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".billing-moment-select .vs--single .vs__selected {\n  white-space: nowrap;\n  /* max-width: 99%; */\n  overflow: hidden;\n}\n.billing-moment-select .vs__selected-options{\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  overflow: hidden;\n}\n", ""]);

// exports
